import {
  Component,
  EventEmitter,
  Output,
  signal,
} from '@angular/core';
import {takeUntilDestroyed, toObservable} from '@angular/core/rxjs-interop';
import {catchError, filter, of, switchMap} from 'rxjs';
import {SearchService} from '../../../services/search.service';
import {GlobalSearchModel} from '../../../models/search/global-search.model';
import {PatientGlobalSearchModel} from '../../../models/search/patient-global-search.model';
import {TdoSearchEvent} from '../../../tdo-controls/common/tdo-search/models/TdoSearchEvent';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {MessagingService} from '../../../services/messaging.service';

@Component({
  standalone: false,
  selector: 'app-tdo-global-search',
  templateUrl: './tdo-global-search.component.html',
  styleUrls: ['./tdo-global-search.component.scss'],
})
export class TdoGlobalSearchComponent {
  @Output() clickedOutside = new EventEmitter<void>();

  patients = signal<PatientGlobalSearchModel[]>([]);

  /** Drives global search; `equal: () => false` so duplicate values still trigger `toObservable`. */
  private readonly searchEvent = signal<TdoSearchEvent | null>(null, {
    equal: () => false,
  });

  constructor(
    private searchService: SearchService,
    private messagingService: MessagingService,
  ) {
    toObservable(this.searchEvent)
      .pipe(
        filter((e): e is TdoSearchEvent => e !== null),
        switchMap((event) =>
          this.searchService.globalSearch(event.value).pipe(
            catchError(() => of<GlobalSearchModel>({patients: []})),
          ),
        ),
        takeUntilDestroyed(),
      )
      .subscribe((res) => {
        this.patients.set(res.patients ?? []);
      });
  }

  onClickOutside() {
    this.clickedOutside.emit();
  }

  onSearchChange(event: TdoSearchEvent) {
    this.searchEvent.set(event);
  }

  loadPatient(patient: PatientGlobalSearchModel) {
    //this.globals.currentPatientId = patient.patient.PatientId;
    this.messagingService.broadCastMessage(MessagingConstants.PATIENT_CHANGED, {
      PatientID: patient.patient.PatientId,
      // PatientName: user.PatientName,
      clearCurrentQuery: false,
    });
    this.clickedOutside.emit();
  }
}
